import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { clsx } from 'clsx';

interface Props {
  playbook?: Record<string, any> | null;
  brief?: Record<string, any> | null;
  ad?: Record<string, any> | null;
  creative?: Record<string, any> | null;
  asset?: Record<string, any> | null;
  state: string;
}

type Segment = {
  label: string;
  value: string | null;
  onClick?: () => void;
};

export function LineageBreadcrumb({ playbook, brief, ad, creative, asset, state }: Props) {
  const navigate = useNavigate();

  const segments: Segment[] = [
    {
      label: 'Playbook',
      value: (playbook?.name as string) ?? (playbook?.id as string) ?? null,
      onClick: playbook?.id
        ? () => navigate(`/creative/strategy?playbook_id=${playbook.id}`)
        : undefined,
    },
    {
      label: 'Brief',
      value: (brief?.title as string) ?? (brief?.brief_id as string) ?? null,
      onClick: brief?.brief_id
        ? () => navigate(`/creative/briefs/${brief.brief_id}`)
        : undefined,
    },
    {
      label: 'Ad',
      value: (ad?.ad_id as string) ?? null,
    },
    {
      label: 'Creative',
      value: (creative?.creative_id as string) ?? null,
      onClick: creative?.creative_id
        ? () => navigate(`/creative/assets/creative/${creative.creative_id}`)
        : undefined,
    },
    {
      label: 'Asset',
      value: (asset?.asset_id as string) ?? null,
    },
  ];

  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1.5 flex-wrap">
        {segments.map((seg, idx) => (
          <div key={seg.label} className="flex items-center gap-1">
            <button
              onClick={seg.onClick}
              disabled={!seg.onClick || !seg.value}
              className={clsx(
                'text-[11px] font-mono px-1.5 py-0.5 rounded border',
                seg.value
                  ? 'bg-white border-slate-200 text-navy-900 hover:bg-slate-50'
                  : 'bg-slate-50 border-slate-100 text-slate-300',
                !seg.onClick && 'cursor-default',
              )}
            >
              <span className="text-slate-400 mr-1">{seg.label}</span>
              {seg.value ?? '—'}
            </button>
            {idx < segments.length - 1 && (
              <ChevronRight size={10} className="text-slate-300" />
            )}
          </div>
        ))}
      </div>
      <div className="text-[10px] font-mono text-slate-400">
        lineage_state: <span className="text-navy-900">{state}</span>
      </div>
    </div>
  );
}
